import { TabBar } from '@app/components/Tab';
import useAuthority from '@app/hooks/useAuthority';
import { useCurrentUserRole } from '@app/hooks/workspace';

import SettingTabMenuItem from './SettingTabMenuItem';

function SettingTabMenu() {
  const { data } = useAuthority();

  const hasApiMenuAuthority = data ? data.permissions.API || data.permissions.WEBHOOK : false;
  const role = useCurrentUserRole();

  const tabMenus: Array<{ activeUrls?: string[]; title: string; to: string; visible: boolean }> = [
    { title: '내 정보', to: '/settings/profile', visible: true },
    {
      activeUrls: ['/settings/plan', '/settings/billing'],
      title: '요금제 / 결제',
      to: '/settings/plan',
      visible: true,
    },
    { title: '주소록', to: '/settings/address-book', visible: true },
    { title: '알림', to: '/settings/alarm', visible: true },
    { title: '워크스페이스 / 멤버', to: '/settings/workspace', visible: true },
    { title: '맞춤 브랜딩', to: '/settings/custom-branding', visible: true },
    {
      activeUrls: ['/settings/api', '/settings/webhook'],
      title: 'API',
      to: '/settings/api',
      visible: hasApiMenuAuthority,
    },
    {
      title: '애플리케이션',
      to: '/settings/applications',
      visible: hasApiMenuAuthority && role?.type === 'ADMIN',
    },
    { title: '외부 서비스', to: '/settings/external-service', visible: true },
  ];

  return (
    <TabBar>
      {tabMenus.map((menu) => (
        <SettingTabMenuItem
          activeUrls={menu.activeUrls}
          key={menu.to}
          title={menu.title}
          to={menu.to}
          visible={menu.visible}
        />
      ))}
    </TabBar>
  );
}

export default SettingTabMenu;
